import { render, staticRenderFns } from "./setAccounts.vue?vue&type=template&id=10b95cd1&scoped=true"
import script from "./setAccounts.vue?vue&type=script&lang=ts"
export * from "./setAccounts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b95cd1",
  null
  
)

export default component.exports